module.exports = __webpack_public_path__ + "static/pooh-534029865d798922386a764218d16e2c.jpg";